export default __webpack_public_path__ + "static/media/call2.3c46e619.jpeg";